import React, {Component, Fragment} from 'react';
import ReactDOM from 'react-dom';
import {observer} from 'mobx-react';
import EditModal from "./components/EditModal";
import ExtendedPopup from "./components/ExtendedPopup";
import intl from 'react-intl-universal';

import "./PopupContainer.css";

@observer
class PopupContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteConfirmation: false
        };
        this.portalContainer = document.getElementById('root');
    };


    handleDeleteConfirmation = () => {
        this.setState({
            deleteConfirmation: true
        })
    };

    handleSave = () => {
        if (this.props.appStore.elementStore.inStore(this.props.appStore.pendingState.element)) {
            this.props.appStore.elementStore.updateElement(this.props.appStore.pendingState.element.uuid, this.props.appStore.pendingState.element);
        } else {
            this.props.appStore.elementStore.addElement(this.props.appStore.pendingState.element);
        }
        this.props.appStore.clearPending();
    };

    handleDelete = () => {
        this.props.appStore.elementStore.removeElement(this.props.appStore.pendingState.element.uuid);
        this.props.appStore.clearPending();
        this.setState({
            deleteConfirmation: false
        });
    }

    handleCancel = () => {
        if (!this.props.appStore.pendingState.editing) {
            this.props.appStore.elementStore.removeElement(this.props.appStore.pendingState.element.uuid);
        }
        this.props.appStore.clearPending();
        this.setState({
            deleteConfirmation: false
        });
    }

    componentDidCatch(error, info) {
        console.log('PopupContainer componentDidCatch: ' + error);
    }

    getConfirmationText(elementTypeText) {
        let iconText;

        switch (elementTypeText) {
            case ('polygon'):
                iconText = intl.get("polygon");
                break;
            case ('marker'):
                iconText = intl.get("icon");
                break;
            case ('polyline'):
                iconText = intl.get("polyline");
                break;
        }
        return intl.get("EditModal.deleteConfirmationText", {icon_type: iconText})
    }

    getElement() {
        const elementTypeText = this.props.appStore.pendingState.element.type;
        if (this.state.deleteConfirmation) {
            return (
                <div className="deleteConfirmation">
                    <h3>{intl.get("EditModal.deleteConfirmation")}</h3>
                    <p>{this.getConfirmationText(elementTypeText)}</p>
                    <div className="buttons">
                        <button className="cancel" onClick={this.handleCancel}>
                            {intl.get("EditModal.cancel")}
                        </button>
                        <button className="delete" onClick={this.handleDelete}>
                            {intl.get("EditModal.delete")}
                        </button>
                    </div>
                </div>
            );
        } else {
            if (!this.props.isMobile) {
                if (this.props.appStore.pendingState.element.type === 'icon') {
                    return (
                        <div className="PopupContainer">
                            <ExtendedPopup position={this.props.appStore.pendingState.element.position}>
                                <EditModal handleDeleteConfirmation={this.handleDeleteConfirmation}
                                           appStore={this.props.appStore} handleSave={() => this.handleSave()}/>
                            </ExtendedPopup>
                        </div>
                    );
                } else {
                    return (
                        <div
                            className={`PopupContainer fixed ${this.props.appStore.pendingState.editing ? 'editing' : ''}`}>
                            <EditModal handleDeleteConfirmation={this.handleDeleteConfirmation}
                                       appStore={this.props.appStore} handleSave={() => this.handleSave()}/>
                        </div>
                    );
                }
            } else {
                return (
                    <div className="PopupContainer">
                        <EditModal handleDeleteConfirmation={this.handleDeleteConfirmation}
                                   appStore={this.props.appStore} handleSave={() => this.handleSave()}/>
                    </div>
                );
            }
        }
    }

    render() {
        return ReactDOM.createPortal((
            <div className={(this.props.appStore.isMobile) ? "PopupContainer-wrapper mobile" : "PopupContainer-wrapper desktop"}>
                {!this.props.appStore.pendingState.editing && (
                    <div className="PopupContainer-gutter" onClick={() => this.handleSave()} />
                )}
                {this.getElement()}
            </div>
        ), this.portalContainer);
    }
}

export default PopupContainer;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PopupContainer/index.js